import { render, staticRenderFns } from "./BusinessBlockTime.vue?vue&type=template&id=5053c3b4"
import script from "./BusinessBlockTime.vue?vue&type=script&lang=js"
export * from "./BusinessBlockTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports